<template>
  <div class="news-all">
    <div class="title"><span class="time">05.31<br>2016</span><span class="tiel">美菜正在风口 为何要做“美菜节”</span></div>
	<div class="mat-content">
		<p align="center"><img src="https://img-oss.yunshanmeicai.com/cfile/c176434ccce6b33953b82d9b564390d8.jpg" width="640"></p>
		<div class="tet-js">导读：<br/><br/>

食材B2B市场风起云涌，美菜已在一年多的时间内完成四次融资，累积融资已超10亿人民币，这样的融资速度及发展节奏令业界惊叹，美菜的快速发展扩张也将美菜推向行业前沿。<br/><br/>

而在未来几年，互联网向农村、农业的下沉，农业产业化、现代化进程的加速，包括国家相关政策的扶持，对于整个中国农业的发展，对于美菜、必将都是一个巨大机会。在2016年伊始，作为食材B2B的领跑者，美菜又展开了新一轮市场营销动作，将倾力打造食材B2B领域首个促销盛典—“1.10美菜节”。有关“美菜节”、互联网+农业、农业现代化等问题，记者采访了美菜的创始人刘传军，他说出了自己的一些看法。
		</div>
	</div>
	<div class="mat-content">
		<div class="title-bold"><span></span>对于美菜而言，农业互联网是什么？意味着什么？</div>
		<div class="tet-js">在过去的30多年，一直是推进中国工业现代化进程的30年。若纵观整个中国工业的发展，会发现，中国工业经历了外资进入——外贸出口——工业现代化三个阶段。但是从2014年开始，中国经济增长放缓，若想继续保持经济稳定增长，无论是从目前国家政策导向，还是整个大势所趋。我个人判断：是农业，是农业现代化。而对于美菜而言，正好处于这样一个大背景下，正好处于这样一个时代浪潮之下。
</div>
	</div>
	<div class="mat-content">
		<div class="title-bold"><span></span>那您认为农业现代化会是怎样的进程？</div>
		<div class="tet-js">我认为农业现代化会为三步走：<br/><br/>
			<b>第一步：农产品流通的现代化，就是农产品的内贸。</b><br/><br/>
			
			农产品从地头卖到城市，把农产品从地头到城市的流通环节打通，拉动内需，带动农产品的高效流通。比如，希望美菜可以实现12小时内完成农产品从地头到商户的交付。12个小时，也就意味着对于任何一种农产品的保鲜度都是最好的。目前，我们已经有很多叶菜类可以实现10小时交付。如果在未来，中国的农产品都可以在10小时之内完成一站式交付，那也就意味着农产品从地头到城市的流通环节打通了，城市的消费者能够得到健康的，放心的，有优惠价格的农产品。农民的积极性也会大大得到提升，收入也会得到保证，这对于城市务工人员返乡也会起到积极推动作用。<br/><br/>

<b>第二步：投资。</b> <br/><br/>

农产品流通的现代化对于农业发展的促进，必然会吸引大量的产业资本投资到农业中去。投资只是个切入点，投资之后要经营、要种植、要养殖、要管理，一定会把许多先进的管理理念、人才、技术，各种资源带到农业里去，这样就会大规模快速地驱动农业的变革。也必将推动农业的产业化、标准化和现代化。届时，我们现在遇到的很多问题也会迎刃而解。比如：在北京，我们现在一天需要5000筐鸡蛋，十几个养殖场供不上，没有能够稳定供应鸡蛋的养殖场，而且还存在很多问题，比如皮太薄等等。当大量资本介入农村市场以后，这些问题都会慢慢解决。<br/><br/>

<b>第三步：农业现代化。</b> <br/><br/>

当产业资本进入到农业后，资本的逐利性，必然会促使其寻求全世界最先进的人才、技术、设备、管理理念、金融服务等，并将其带入农业农村。这样势必会提升农业的现代化种植，刺激生产力以及生产效率的大幅提升，提高农业的种植生产、仓储、采植的效益，以真正实现农业现代化。农业现代化，农产品的规模化生产，又必需要有一个天然的合作伙伴，天然的平台，一边对接产地，一边对接需求方。而美菜正是这样的平台，这对于我们来说也是历史性的机会。怎么抓住，特别重要。
		</div>
	</div>
	<div class="mat-content">
		<div class="title-bold"><span></span>为什么要做“美菜节”？</div>
		<div class="tet-js">在之前乌镇的互联网大会上，我曾谈到目前食材O2O行业所面临的几个问题，其中包括两点，一是商户线上支付能力问题。目前，中小餐饮里面，移动支付能力很弱，70-80%还是线下支付。二是企业运营效率还需大幅提升。而在扩大市场规模以及解决客户留存率的问题上，服务和团队执行力将起到至关重要的作用。为此，我们创建“1.10美菜节”的意义在于：<br/><br/>

第一：美菜的快速成长，离不开广大商户的支持。为此我们将每年1月10日定为“美菜节”，并开展为期五天的“餐饮购物周”活动，回馈感谢商户。<br/><br/>

第二：服务和团队执行力是商户的留存的关键因素。我们也期望通过这样一场大投入，整合公司全部资源的活动，能够将对客户的服务持续优化，并将服务做到极致。而通过这样的活动，也可以促使美菜上升到另一个高度，然后去更快速的奔跑。<br/><br/>

第三：改变商户习惯。我们的商户过去都习惯货到付款。1.10美菜节期间，我们会通过和更多优惠、折扣、促销和秒杀的捆绑，刺激商户支付习惯的改变，并逐渐习惯线上支付。而这，不只对于美菜，对于整个行业来说，都有着积极的、非常大的意义。</div>
	</div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
